import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'
import { axsToken } from '../_helpers/auth-header'
import { store } from '../_helpers/store';

export const rolesService = {
  addRole,
  updateRole,
  archiveRole,
  retrieveRole,
  retrieveRoles,
  retrieveOptionsRoles
};

function addRole(role) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/roles`,
    data: {
      ...role,
      providerId: clientId
    }
  })
}

function updateRole(role, id) {
  return axiosInstance.request({
    method: 'PATCH',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/roles/${id}`,
    data: role
  })
}

function archiveRole(id, roleSelected = null) {
  return axiosInstance.request({
    method: 'DELETE',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/roles/${id}`,
    data: { roleId: roleSelected }
  })
}

function retrieveRole(id) {
  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/roles/${id}`
  })
}

function retrieveOptionsRoles() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/options-role?providerId=${clientId}`
  })
}

function retrieveRoles(page = 1) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    headers: axsToken(),
    url: `${process.env.REACT_APP_API2_URL}/${apiVersion()}/client/roles?providerId=${clientId}&page=${page}`
  })
}